<template>
  <div>
    <table>
      <thead>
        <tr>
          <th class="product-header">Product</th>
          <th class="product-title">Product Title</th>
          <th class="product-size">Option</th>
          <th class="product-quantity">Quantity</th>
          <th class="product-subtotal" v-show="showPrices">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>
            <div class="flex items-center justify-center">
              <img :src="item.variantImage" />
            </div>
          </td>
          <td>{{ item.productName }}</td>
          <td>
            <span class="enter-line">{{ displaySelection(item) }}</span>
          </td>
          <td>{{ item.quantity }}</td>
          <td v-show="showPrices">{{ formatCurrency(item.amount) }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr v-for="i in 5" :key="i">
          <td
            v-for="j in 6"
            :key="j"
            :class="{
              left: j === 4,
              right: j !== 4,
              'pt-2': i > 1,
              bold: i === 4,
              light: i === 4 && j === 4,
              'total-box': i === 5 && j === 4,
              'total-cost-box': i === 5 && j === 5
            }"
            :colspan="i === 4 && j === 4 ? 2 : 1"
          >
            {{ hanldeSingle(i, j) }}
          </td>
        </tr>
      </tfoot>
      <!-- <tfoot v-show="showPrices">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>Total</td>
          <td>{{ totalAmount }}</td>
        </tr>
      </tfoot> -->
    </table>
  </div>
</template>

<script>
import DateFns from '@/mixins/DateFns'
import Util from '@/mixins/Util'
import { mapState } from 'vuex'

export default {
  name: 'OrderItemGrid',
  mixins: [DateFns, Util],
  props: {
    items: Array
  },

  computed: {
    ...mapState({
      order: state => state.order.individualOrder
    }),
    subTotal() {
      return this.formatCurrency(this.order.subtotal)
    },
    totalAmount() {
      return this.formatCurrency(this.order.total)
    },

    showPrices() {
      return this.$store.getters['team/showPrices']
    },

    shippingFee() {
      return this.formatCurrency(this.order.shippingFee)
    }
  },

  methods: {
    hanldeSingle(i, j) {
      if (j === 4) {
        switch (i) {
          case 1:
            return 'Subtotal'
          case 2:
            return ''
          case 3:
            return 'Shipping'
          case 4:
            return ``
          case 5:
            return 'Total'
          default:
            return ''
        }
      } else if (j === 5) {
        switch (i) {
          case 1:
            return this.subTotal
          case 2:
            return ''
          case 3:
            return this.shippingFee
          case 4:
            return ''
          case 5:
            return this.totalAmount
          default:
            return ''
        }
      }
    },
    showSizeIf(product) {
      if (product.size !== '-' && product.size !== undefined) {
        return true
      }

      return false
    },
    displaySelection(variant) {
      if (variant) {
        let selections = []
        if (variant.type) selections.push(variant.type)
        if (variant.color) selections.push(variant.color)
        if (variant.size) selections.push(variant.size)

        return selections.map(selection => selection).join('\n')
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

table {
  width: 100%;
  margin-top: 2rem;
  border-spacing: 0px;
  border-collapse: separate;

  & thead > tr > th {
    color: $main-6;
    font-size: 0.875rem;
    padding: 1rem;
    border-bottom: 1px solid $onyx;
  }

  & tbody > tr > td {
    color: $main-6;
    font-size: 0.813rem;
    padding: 0.25rem;
    border-bottom: 1px solid $onyx;
  }

  & tbody > tr > td:nth-child(2) {
    padding-left: 0.75rem;
    text-align: left;
  }

  & tfoot > tr > td {
    font-size: 0.813rem;
    padding-top: 1.5rem;
  }

  & tfoot > tr:nth-child(2) {
    display: none;
  }
  & tfoot > tr:nth-child(4) {
    display: none;
  }
  & tfoot > tr > td:nth-child(4) {
    font-weight: 700;
    padding-left: 3rem;
    padding-right: 1rem;
    text-align: right;
  }
  & tfoot > tr > td:nth-child(5) {
    padding-left: 0.8rem;
    text-align: left;
  }
  & tfoot > tr:nth-child(3) > td {
    padding-bottom: 1rem !important;
  }
  & tfoot > tr:nth-child(2) > td:nth-child(4) {
    padding-top: 5px;
  }
  & tfoot > tr:nth-child(2) > td:nth-child(5) {
    padding-top: 5px;
  }
  & tfoot > tr:nth-child(3) > td:nth-child(4) {
    padding-top: 5px;
  }
  & tfoot > tr:nth-child(3) > td:nth-child(5) {
    padding-top: 5px;
  }
  & tfoot > tr:nth-child(4) > td:nth-child(4) {
    padding-top: 1.5rem;
  }
  & tfoot > tr:nth-child(4) > td:nth-child(5) {
    padding-top: 1.5rem;
  }

  & tfoot {
    .cost-summary {
      position: relative;
      right: 30px;
      width: 70%;
      margin: 0px auto;
      padding: 0px 10px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 0.2rem 0.8rem;

      .total-text {
        font-size: 0.813rem;
        font-weight: 700;
        text-align: right;
      }

      .cost-figure {
        font-weight: 400;
        text-align: left;
      }
      .shipping-method {
        grid-column: span 2;
        font-size: 12px;
      }
    }
    @media (min-width: 908px) {
      .cost-summary {
        right: 25px;
      }
    }
    @media (min-width: 922px) {
      .cost-summary {
        right: 20px;
      }
    }
    @media (min-width: 1024px) {
      .cost-summary {
        right: 10px;
      }
    }
    @media (min-width: 1240px) {
      .cost-summary {
        right: 20px;
      }
    }
    @media (min-width: 1241px) {
      .cost-summary {
        right: 0px !important;
      }
    }
  }
  & tfoot > tr:nth-child(3) > td:nth-child(4) {
    .total-box {
      background-color: #dfdad2;
      width: 60%;
      margin: 0px auto;
      padding: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      justify-content: center;
      gap: 0.2rem 0.8rem;
      position: relative;
      right: 30px;
      &.left {
        text-align: right !important;
      }
      .total-text {
        font-size: 0.813rem;
        font-weight: 700;
        text-align: right;
      }
      .cost-figure {
        font-weight: 400;
        padding-left: 0.2rem;
        // text-align: center;
      }
    }
    @media (min-width: 820px) {
      .total-box {
        right: 15px;
        width: 80%;
      }
    }
    @media (min-width: 922px) {
      .total-box {
        right: 10px;
      }
    }
    @media (min-width: 1024px) {
      .total-box {
        width: 60%;
      }
    }
    @media (min-width: 1240px) {
      .total-box {
        right: 0px;
      }
    }
  }
  & tfoot > tr:nth-child(2) > td:nth-child(5) {
    padding-top: 5px;
  }

  .product-header {
    width: 20%;
  }

  .product-title {
    width: 35%;
    text-align: left;
  }
}

img {
  width: 120px;
  height: 120px;
  max-width: 100%;
  object-fit: scale-down;
}

.flexbox-container {
  display: flex;

  .header {
    padding: 1.5rem 0;
  }

  .column-image {
    width: 16%;
  }

  .column-description {
    width: 30%;
  }

  .column-quantity {
    width: 15%;
  }

  .content {
    padding-bottom: 0.5rem;

    img {
      max-width: 60%;
    }

    .item-name {
      font-weight: bold;
      padding-bottom: 1rem;
      font-size: $content-font-size;
    }

    span {
      font-size: $body-base;
      opacity: 0.6;
    }
  }
}

.flexbox-container > div {
  width: 15%;
  text-align: left;
  padding: 0rem 0rem;
  margin-right: 20px;
}

.bold {
  font-weight: bold;
}

.light {
  border-bottom: none;
  padding-top: 0px !important;
  height: max-content !important;
  font-weight: 400 !important;
  font-size: 0.68rem;
  padding-bottom: 1.25rem;
}

.left {
  text-align: left;
  padding-left: 6.4rem !important;
}

.right {
  text-align: left;
  padding-left: 4px;

  &.multiple-recipient {
    padding-right: 0rem !important;
    text-align: left;
  }
  padding-left: 0.9rem;
}

.right-multiple-recipient {
  text-align: right !important;
  padding-left: 0 !important;
  padding-bottom: 0.5rem !important;
}

.left-multiple-recipient {
  text-align: left !important;
  padding-left: 1.7rem !important;
  padding-bottom: 0.5rem !important;
}

@media (max-width: 998px) {
  .left {
    padding-left: 2rem !important;
  }
  .right {
    padding-left: 1rem !important;
  }
  .right-multiple-recipient {
    text-align: right !important;
    padding-left: 0 !important;
    padding-bottom: 0.5rem !important;
  }
  .left-multiple-recipient {
    text-align: left !important;
    padding-left: 1.7rem !important;
    padding-bottom: 0.5rem !important;
  }
}

.total-box {
  background-color: #dfdad2;
  margin-left: 6.4rem !important;
  display: block;
  padding-left: 10px !important;
  text-align: right !important;
  padding-top: 0px !important;
  padding: 10px !important;
  padding-right: 5px !important;
  font-weight: 700;
  font-size: 0.813rem;
  max-width: 100px;
  margin-left: auto !important;
  padding-right: 1rem !important;
}
.total-cost-box {
  background-color: #dfdad2;
  padding-left: 10px !important;
  text-align: left !important;
  padding-top: 0px !important;
  margin-top: 1.25rem;
  padding: 10px !important;
  font-weight: 700;
  padding-left: 15px !important;
  font-size: 0.813rem;
  max-width: 100px !important;
  margin-left: auto !important;
  width: 300px;
}

.multiple-recipient {
  &.total-box {
    padding-left: 1.2rem !important;
    padding-right: 0.1rem !important;
  }
}
.multiple-recipient {
  &.total-cost-box {
    padding-left: 2rem !important;
  }
}

// @media (min-width: 1569px) {
//   .total-box {
//     text-align: left !important;
//   }
// }

@media (min-width: 1400px) {
  .left {
    position: relative;
    left: 10px;
  }
  .total-box {
    padding-right: 15px !important;
  }
  .multiple-recipient {
    &.total-box {
      padding-left: 0rem !important;
      padding-right: 0.1rem !important;
    }
  }
}

.total-region {
  font-family: $inter;
  margin-top: 1rem;
  display: flex;
  justify-content: end;
}

.note {
  background: $dark-gray;
  padding: 1rem;
  text-align: left;
  width: 315px;
  color: #25282a;
  font-size: 0.688rem;
  border-radius: 10px;
}

.total {
  display: flex;
  margin: 2rem 0;
  text-align: left;
  width: 25%;

  p {
    font-weight: 700;
    font-size: 0.875rem;

    &:nth-child(2) {
      margin-left: 3.75rem;
    }
  }
}

.multiple-recipient-light {
  padding-bottom: 1.25rem !important;
}

.multiple-recipient-info {
  border-bottom: none !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  gap: 0.5rem;

  .content {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    img {
      width: 14px;
      height: 14px;
    }

    .text {
      font-weight: 400;
      margin: 0;
      position: relative;
      top: -3px;

      button {
        font-weight: 700;
        font-family: $inter;
        text-decoration: none;
        color: #232220;

        &:hover {
          color: #232220;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
